module.exports = __webpack_public_path__ + "static/media/loading.6f2c7c68.png";